import * as React from 'react';
import { Nav, NavItem, NavLink } from 'react-bootstrap';
import { Translate } from 'react-localize-redux';
import styled from 'styled-components';
import { PrimaryColor, BorderColor, SidelyBlack } from '../../styles/global/css/Utils';
import { FormTemplate } from '../forms/jsonValidator';
import RestrictedAllowDenyList from '../permissions/RestrictedAllowDenyList';
import { TOOLBARS_HEIGHT } from '../globals/defaultToolbar/style/Style';

const GalleryText = styled.div<{ selected: boolean }>`
  font-weight: ${p => (p.selected ? 'bold' : '')};
  transition: color 0.1s;

  &:hover {
    color: ${PrimaryColor};
  }
`;

const GalleryTiles = styled.div`
  min-height: 40px;
  cursor: pointer;
  font-size: 12px;
  width: 100%;

  &:first-child .nav-link {
    border-top: 1px solid ${BorderColor} !important;
  }
`;

const StyleDiv = styled.div`
  .nav-link {
    min-height: 40px;
    margin: 0;
    display: flex;
    align-items: center;
    padding: 0 1.25rem;
    overflow: hidden;
    border-top: 0 !important;
  }

  .nav-item {
    height: 100%;
  }
`;

export function GalleryModalLeft(props: {
	setSelected: (type: FormTemplate) => void;
	selected: FormTemplate | undefined;
	templateList: FormTemplate[];
	isModalOpen: boolean;
	setIsModalOpen: (type: boolean) => void;
}): JSX.Element {
	return (
		<StyleDiv
			className="filter-modal"
			style={{
				top: TOOLBARS_HEIGHT,
				height: `calc(100% - ${TOOLBARS_HEIGHT}px)`,
				zIndex: 2,
				left: props.isModalOpen ? '4px' : '-261.2px',
				transition: 'left 0.25s'
			}}
		>
			<div
				className={'box-filter-modal'}
				style={{
					width: '261.2px',
					borderRight: props.isModalOpen ? undefined : 'none'
				}}
			>
				<h5 className="p-3" style={{ color: SidelyBlack, fontSize: 13, fontWeight: 'bold' }}>
					<Translate id="forms" />
				</h5>
				<Nav className="nav-pin">
					{...props.templateList.map(template => (
						<RestrictedAllowDenyList key={template.name} target='ReadForm' target_id={template.id}>
							<GalleryTiles key={`Typelist[${template.name}]`}>
								<NavItem key={template.name}>
									<NavLink
										data-active={props.selected == template || undefined}
										onClick={_e => {
											if (props.selected !== template) props.setSelected(template);
										}}
									>
										<GalleryText selected={props.selected == template}>
											{template.name}
										</GalleryText>
									</NavLink>
								</NavItem>
							</GalleryTiles>
						</RestrictedAllowDenyList>
					))}
				</Nav>
			</div>
		</StyleDiv >
	);
}

export default GalleryModalLeft;
